import homeView from './views/TemplateHome';
import landingpageView from './views/TemplateLandingpage';
import articleView from './views/SingleArticle';
import articleTemplateView from './views/TemplateArticles';
import pressTemplateView from './views/TemplatePress';
import pressView from './views/SinglePress';
import t404View from './views/404';
import aboutView from './views/TemplateAbout';
import contactView from './views/TemplateContact';
import discoverView from './views/TemplateDiscover';
import faqView from './views/TemplateFaq';
import caregiversHubView from './views/TemplateCaregiversHub';
import subjectTermView from './views/TemplateSubjectTerm';

export default [
	homeView,
	articleTemplateView,
	articleView,
	pressTemplateView,
	pressView,
	t404View,
	aboutView,
	contactView,
	discoverView,
	landingpageView,
	faqView,
	caregiversHubView,
	subjectTermView,
];
